/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import {
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
} from "./resetPasswordTypes";
import axios from "axios";
import Config from "../../../config/index";

let baseUrl = Config.baseUrl;
let userManagementUrl = Config.userManagementUrl;

const resetPasswordRequest = () => {
  return {
    type: RESET_PASSWORD_REQUEST,
  };
};

const resetPasswordSuccess = (payload) => {
  return {
    type: RESET_PASSWORD_SUCCESS,
    payload: payload,
  };
};

const resetPasswordFaliure = (error) => {
  return {
    type: RESET_PASSWORD_FAILURE,
    payload: error,
  };
};

const resetPassword = (resetPasswordState) => {
  return (dispatch) => {
    // let payload = {
    //   email: resetPasswordState.email,
    //   password: resetPasswordState.newpassword,
    //   // oldpassword: resetPasswordState.oldpassword,
    //   // newpassword: resetPasswordState.newpassword,
    //   // clientId: resetPasswordState.clientId,
    // };
    dispatch(resetPasswordRequest());
    let url = `${userManagementUrl}/user/change_password`;
    return axios
      .put(url, resetPasswordState)
      .then((response) => {
        dispatch(resetPasswordSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(resetPasswordFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export { resetPassword };
